<template>
    <v-app-bar app class="toolbar transparent" flat absolute>
        <v-app-bar-nav-icon
                v-if="this.$store.state.user"
                @click.stop="$emit('navigationDrawerClicked')"
        />

        <v-toolbar-title style="cursor: pointer;"
                         @click="$router.push({name: 'home'})">Eldritch Tracker
        </v-toolbar-title>

        <v-spacer/>

        <v-btn
                class="nav-btn black--text text-uppercase"
                large
                color="white"
                @click="$router.push({name: 'signin'})"
                v-if="!$store.state.user && $route.name !== 'signin' && $route.name !== 'signup'"
        >Sign in
        </v-btn>
    </v-app-bar>
</template>

<script>
  export default {
    data: () => ({
      drawer: false
    }),
  };
</script>
